export enum DeviceFamily {
	LiberoGx = 'LIBERO Gx',
	EcologProXG = 'ECOLOG-PRO xG',
	EcologProRadio = 'ECOLOG-PRO RADIO',
}
